export const CREATE_DOCUMENT = "CREATE_DOCUMENT";
export const FETCH_DOCUMENTS = "FETCH_DOCUMENTS";
export const FETCH_DOCUMENT = "FETCH_DOCUMENT";
export const EDIT_DOCUMENT = "EDIT_DOCUMENT";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const FETCH_VEHICLE_DOCUMENT_TYPE_DDL =
  "FETCH_VEHICLE_DOCUMENT_TYPE_DDL";
